import {Injectable} from '@angular/core';

export interface PaymentDraftInvoice {
  id: string | number;
  number: string;
  entity_id: string | number;
  entity_name?: string;
  detail_total: number;
  payment_applied_total: number;
  due_date?: string;
  header_date?: string;
  description?: string;
  subLedger?: string; // 'ar' | 'ap'
}

export interface PaymentDraft {
  entityId: string | number;
  entityName: string;
  paymentId: string; // 'newAR' | 'newAP'
  invoices: PaymentDraftInvoice[];
}

@Injectable({providedIn: 'root'})
export class PaymentDraftService {
  private draft: PaymentDraft | null = null;

  set(draft: PaymentDraft): void {
    this.draft = draft;
  }

  get(): PaymentDraft | null {
    return this.draft;
  }

  consume(): PaymentDraft | null {
    const d = this.draft;
    this.draft = null;
    return d;
  }

  clear(): void {
    this.draft = null;
  }
}
